/**
 * Wordpress data selectors
 */

import { createSelector } from 'reselect';
const basketData = state => state.basket;
const infoData = state => state.info;
const paymentData = state => state.payment;
const makeSelectData = () => createSelector(basketData, substate => substate.data);

const makeSelectTransfers = () =>
  createSelector(basketData, substate => {
    if (substate.data) {
      return substate.data.transfers;
    }
  });

const makeSelectOptions = () =>
  createSelector(basketData, substate => {
    const transferTypeOutbound = substate.data.transfers && substate.data.transfers[0].transferType;
    const transferTypeInbound =
      substate.data.transfers && substate.data.transfers[1] && substate.data.transfers[1].transferType;

    if (substate.data) {
      return {
        availableCurrencies: substate.data.availableCurrencies,
        currency: substate.data.currency,
        transferOptions: substate.data.options,
        optionsStatus: substate.data.optionsStatus,
        selectedTransferTypeDataOutbound: transferTypeOutbound,
        selectedTransferTypeDataInbound: transferTypeInbound
      };
    }
  });

const makeSelectMoney = () =>
  createSelector(basketData, substate => {
    if (substate.data) {
      return {
        availableCurrencies: substate.data.availableCurrencies,
        currency: substate.data.currency,
        totalCost: substate.data.totalCost,
        totalToPay: substate.data.totalToPay,
        promoValue: substate.data.promoValue
      };
    }
  });
const makeSelectLoading = () => createSelector(basketData, substate => substate.isLoading);
const makeSelectError = () =>
  createSelector(basketData, substate => {
    return {
      hasFailed: substate.hasFailed
    };
  });

const makeSelectInfo = () =>
  createSelector(infoData, substate => {
    return {
      help: substate.data.help,
      seatTypes: substate.data.seatTypes,
      childAges: substate.data.childAges,
      paymentCardTypes: substate.data.paymentCardTypes,
      paymentCountries: substate.data.paymentCountries
    };
  });
const makeSelectPayment = () =>
  createSelector(paymentData, substate => {
    if (substate.data) {
      return {
        ...substate
      };
    }
  });

export {
  makeSelectData,
  makeSelectTransfers,
  makeSelectOptions,
  makeSelectLoading,
  makeSelectError,
  makeSelectMoney,
  makeSelectInfo,
  makeSelectPayment
};



// WEBPACK FOOTER //
// ./src/containers/QuotePage/selectors.js